import { render, staticRenderFns } from "./GradientBar.vue?vue&type=template&id=7a80fb5c&"
import script from "./GradientBar.vue?vue&type=script&lang=js&"
export * from "./GradientBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports